import React from "react";
import clsx from "clsx";
import { useResizeDetector } from "react-resize-detector";

import {
  createStyles,
  withStyles,
  StyleRules,
  WithStyles,
} from "@material-ui/core";

import { HvTooltip, HvTypography } from "@hitachivantara/uikit-react-core";

const styles: StyleRules = createStyles({
  tooltipData: {},
  tooltipAnchor: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  tooltipAnchorParagraph: {
    overflow: "hidden",
    display: "-webkit-box",
    "-webkit-line-clamp": 2,
    "-webkit-box-orient": "vertical",
  },
});

const isParagraph = (children: string): boolean => /\s/.test(children);

export type OverflowTooltipProps = WithStyles<typeof styles> & {
  className?: string;
  data: NonNullable<React.ReactNode>;
  paragraphOverflow?: boolean;
};

function OverflowTooltip({
  className,
  classes,
  data,
  paragraphOverflow,
}: OverflowTooltipProps) {
  const { width = 0, ref } = useResizeDetector({
    refreshMode: "debounce",
    refreshOptions: {
      trailing: true,
    },
    handleHeight: false,
  });

  const isOverflowing = ref.current?.scrollWidth > width;

  const isParag = paragraphOverflow && isParagraph(data.toString());
  return (
    <HvTooltip
      disableHoverListener={!isOverflowing}
      placement="top-start"
      title={
        <HvTypography className={classes.tooltipData} variant="normalText">
          {data}
        </HvTypography>
      }
    >
      <div
        ref={ref}
        className={clsx(className, {
          [classes.tooltipAnchor]: !isParag,
          [classes.tooltipAnchorParagraph]: isParag,
        })}
      >
        {data}
      </div>
    </HvTooltip>
  );
}

export default withStyles(styles, {
  name: "OverflowTooltip",
})(React.memo(OverflowTooltip));
